
import React from 'react';
import { SafeDialogProvider } from './use-safe-dialog';

/**
 * Provider component that wraps all trading-related components
 * with necessary providers for feature flags and configuration.
 */
export const TradingComponentsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // Production builds should always use safe mode
  // Development builds can toggle this for testing
  const isProduction = import.meta.env.MODE === 'production';
  
  return (
    <SafeDialogProvider safeMode={isProduction}>
      {children}
    </SafeDialogProvider>
  );
};
